(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uh-purchase-clean"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePurchase = (root) => {
      if (root.dataset.uhReady) return;
      const form = root.querySelector('form');
      const master = root.querySelector('[data-uh-variant-id]');
      const optionFieldset = root.querySelector('[data-uh-variant-options]');
      if (!form || !master || !optionFieldset) return;
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-uh-variant-data]').textContent); }
      catch { return; }
      if (!Array.isArray(variants) || !variants.length) return;
      const options = [...optionFieldset.querySelectorAll('[data-uh-option]')];
      const price = root.querySelector('[data-uh-price]');
      const deliveryPrice = root.querySelector('[data-uh-delivery-price]');
      const europePrice = root.querySelector('[data-uh-europe-price]');
      const availability = root.querySelector('[data-uh-availability]');
      const button = root.querySelector('[data-uh-add]');
      const fallback = root.querySelector('[data-uh-variant-fallback]');
      const update = () => {
        const selected = options.map((option) => option.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
        const available = Boolean(variant?.available);
        master.value = variant ? String(variant.id) : '';
        master.disabled = !variant;
        if (price) price.textContent = variant ? variant.price : root.dataset.priceLabel;
        deliveryPrice.textContent = variant ? variant.deliveryPrice : root.dataset.priceLabel;
        if (europePrice) europePrice.textContent = variant ? variant.europePrice : root.dataset.priceLabel;
        availability.textContent = variant ? (available ? root.dataset.availableLabel : root.dataset.unavailableLabel) : root.dataset.combinationLabel;
        availability.dataset.available = String(available);
        button.disabled = !available;
        button.textContent = available ? root.dataset.addLabel : root.dataset.unavailableLabel;
        const battery = root.querySelector('[data-uh-battery-property]');
        if (battery && variant) {
          battery.disabled = false;
          battery.value = variant.options.some(value => value.includes('25 km/h')) ? 'Blei-Gel 72 V / 100 Ah' : 'LiFePO₄ 72 V / 150 Ah';
          root.querySelector('[data-uh-battery-summary]').textContent = battery.value;
        }
        const scope = root.closest('[data-uh-product-scope]');
        const productImage = scope?.querySelector('[data-uh-product-image], .uh-model-visual img, .uh-product-media__item--featured img');
        if (productImage && variant?.image) {
          productImage.src = variant.image;
          productImage.removeAttribute('srcset');
          productImage.alt = variant.imageAlt;
        }
        root.dispatchEvent(new CustomEvent('uh:variant-change', {bubbles: true, detail: {variant}}));
        if (variant?.sku && root.dataset.uhModelSku) {
          let sku = variant.sku.replace(/-(STICK|SEAT|CAPTAIN|BOTH)(?:-(STICK|SEAT|CAPTAIN|BOTH))*$/, '');
          if (sku.startsWith('UH-CABIN-MAX-45-') && !sku.includes('-LFP-')) sku = sku.replace('UH-CABIN-MAX-45-', 'UH-CABIN-MAX-45-LFP-');
          root.dataset.selectedSku = sku;
          root.dispatchEvent(new CustomEvent('uh:configuration-change', {bubbles:true, detail:{sku,modelSku:root.dataset.uhModelSku}}));
        }
      };
      const initialVariant = variants.find((candidate) => String(candidate.id) === master.value);
      if (initialVariant) options.forEach((option, index) => { option.value = initialVariant.options[index]; });
      optionFieldset.addEventListener('change', update);
      form.addEventListener('submit', (event) => {
        update();
        if (button.disabled) event.preventDefault();
      });
      update();
      optionFieldset.hidden = false;
      optionFieldset.disabled = false;
      fallback.hidden = true;
      master.required = false;
      root.dataset.uhReady = 'true';
    };
    const initializeAll = (scope) => {
      if (scope.matches?.('[data-uh-purchase]')) initializePurchase(scope);
      scope.querySelectorAll('[data-uh-purchase]').forEach(initializePurchase);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), {once: true});
    } else {
      initializeAll(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uh-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializePurchase = (root) => {
      if (root.dataset.uhReady) return;
      const form = root.querySelector('form');
      const master = root.querySelector('[data-uh-variant-id]');
      const optionFieldset = root.querySelector('[data-uh-variant-options]');
      if (!form || !master || !optionFieldset) return;
      let variants;
      try { variants = JSON.parse(root.querySelector('[data-uh-variant-data]').textContent); }
      catch { return; }
      if (!Array.isArray(variants) || !variants.length) return;
      const options = [...optionFieldset.querySelectorAll('[data-uh-option]')];
      const price = root.querySelector('[data-uh-price]');
      const deliveryPrice = root.querySelector('[data-uh-delivery-price]');
      const europePrice = root.querySelector('[data-uh-europe-price]');
      const availability = root.querySelector('[data-uh-availability]');
      const button = root.querySelector('[data-uh-add]');
      const fallback = root.querySelector('[data-uh-variant-fallback]');
      const update = () => {
        const selected = options.map((option) => option.value);
        const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
        const available = Boolean(variant?.available);
        master.value = variant ? String(variant.id) : '';
        master.disabled = !variant;
        price.textContent = variant ? variant.price : root.dataset.priceLabel;
        deliveryPrice.textContent = variant ? variant.deliveryPrice : root.dataset.priceLabel;
        europePrice.textContent = variant ? variant.europePrice : root.dataset.priceLabel;
        availability.textContent = variant ? (available ? root.dataset.availableLabel : root.dataset.unavailableLabel) : root.dataset.combinationLabel;
        availability.dataset.available = String(available);
        button.disabled = !available;
        button.textContent = available ? root.dataset.addLabel : root.dataset.unavailableLabel;
        const battery = root.querySelector('[data-uh-battery-property]');
        if (battery && variant) {
          battery.disabled = false;
          battery.value = variant.options.some(value => value.includes('25 km/h')) ? 'Blei-Gel 72 V / 100 Ah' : 'LiFePO₄ 72 V / 150 Ah';
          root.querySelector('[data-uh-battery-summary]').textContent = battery.value;
        }
        const scope = root.closest('[data-uh-product-scope]');
        const productImage = scope?.querySelector('[data-uh-product-image], .uh-model-visual img, .uh-product-media__item--featured img');
        if (productImage && variant?.image) {
          productImage.src = variant.image;
          productImage.removeAttribute('srcset');
          productImage.alt = variant.imageAlt;
        }
        root.dispatchEvent(new CustomEvent('uh:variant-change', {bubbles: true, detail: {variant}}));
        if (variant?.sku && root.dataset.uhModelSku) {
          let sku = variant.sku.replace(/-(STICK|SEAT|CAPTAIN|BOTH)(?:-(STICK|SEAT|CAPTAIN|BOTH))*$/, '');
          if (sku.startsWith('UH-CABIN-MAX-45-') && !sku.includes('-LFP-')) sku = sku.replace('UH-CABIN-MAX-45-', 'UH-CABIN-MAX-45-LFP-');
          root.dataset.selectedSku = sku;
          root.dispatchEvent(new CustomEvent('uh:configuration-change', {bubbles:true, detail:{sku,modelSku:root.dataset.uhModelSku}}));
        }
      };
      const initialVariant = variants.find((candidate) => String(candidate.id) === master.value);
      if (initialVariant) options.forEach((option, index) => { option.value = initialVariant.options[index]; });
      optionFieldset.addEventListener('change', update);
      form.addEventListener('submit', (event) => {
        update();
        if (button.disabled) event.preventDefault();
      });
      update();
      optionFieldset.hidden = false;
      optionFieldset.disabled = false;
      fallback.hidden = true;
      master.required = false;
      root.dataset.uhReady = 'true';
    };
    const initializeAll = (scope) => {
      if (scope.matches?.('[data-uh-purchase]')) initializePurchase(scope);
      scope.querySelectorAll('[data-uh-purchase]').forEach(initializePurchase);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document), {once: true});
    } else {
      initializeAll(document);
    }
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
